module.exports = "<div layout=column layout-fill-height=0> <md-content flex class=background layout=column layout-align=\"center center\"> <div layout=column layout-align=\"center center\"> <div layout=row layout-align=\"center center\"> <img src=" + require("../img/maisfrete.png") + " flex flex-sm=60 flex-gt-sm=65 flex-md=65 flex-gt-md=90 /> </div> <div ui-view=conteudo layout=row layout-align=\"center center\"> </div> </div> </md-content> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./pages/app.html
 ** module id = 91
 ** module chunks = 0
 **/